import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import "./TextArea.css";
import Tooltip from "../../uiElements/tooltip/Tooltip";

const TextArea = ({
  value,
  placeholder,
  onChange,
  className,
  label,
  maxLength,
  required,
  error,
}) => (
  <div className="form-group floating mt-n4">
    {required && (
      <span className="text-danger" style={{ marginLeft: 5 }}>
        *
      </span>
    )}

    <textarea
      type="textarea"
      className={classnames("form-control floating text-area", className)}
      placeholder={placeholder}
      required
      title=""
      maxLength={maxLength}
      value={value}
      onChange={e => onChange(e.target.value)}
    />
    {label && (
      <label className="text-left input-label textarea-label">{label}</label>
    )}
    {error && (
      <Tooltip id={error} className="textareaErrorBtn">
        {error}
      </Tooltip>
    )}
  </div>
);

TextArea.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  required: PropTypes.bool,
};

TextArea.defaultProps = {
  value: "",
  onChange: undefined,
  type: "text",
  placeholder: "",
  className: "",
  required: false,
};
export default TextArea;
